import { render, staticRenderFns } from "./SelectedOffer.vue?vue&type=template&id=788f6eb3&scoped=true"
import script from "./SelectedOffer.vue?vue&type=script&lang=js"
export * from "./SelectedOffer.vue?vue&type=script&lang=js"
import style0 from "./SelectedOffer.vue?vue&type=style&index=0&id=788f6eb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f6eb3",
  null
  
)

export default component.exports